import { useCallback, useState } from "react";
import useAnalytics from "./useAnalytics";

const useViewerZoom = () => {
	const { triggerAnalyticsEvent, ANALYTICS_EVENTS } = useAnalytics();

	const [zoom, setZoom] = useState(1);

	const zoomIn = useCallback(() => {
		setZoom((prev) => Math.max(1, prev + 1)); // Math.min(2, prev / CHANGE_SCALE))
		triggerAnalyticsEvent(ANALYTICS_EVENTS.ZOOM_INTERACTION, { direction: 1})
	}, []);

	const zoomOut = useCallback(() => {
		setZoom((prev) => Math.min(-1, prev - 1));
		triggerAnalyticsEvent(ANALYTICS_EVENTS.ZOOM_INTERACTION, { direction: -1 })
	}, []);

	const zoomReset = useCallback(() => {
		setZoom(0);
		triggerAnalyticsEvent(ANALYTICS_EVENTS.ZOOM_INTERACTION, { direction: 0 })
	}, []);

	return {
		zoomDirection: zoom,
		zoomIn,
		zoomOut,
		zoomReset,
	};
};

export default useViewerZoom;
